var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.9999C5.63333 11.9999 5.31956 11.8695 5.05867 11.6086C4.79733 11.3473 4.66667 11.0333 4.66667 10.6666V2.66659C4.66667 2.29992 4.79733 1.98592 5.05867 1.72459C5.31956 1.4637 5.63333 1.33325 6 1.33325H12C12.3667 1.33325 12.6807 1.4637 12.942 1.72459C13.2029 1.98592 13.3333 2.29992 13.3333 2.66659V10.6666C13.3333 11.0333 13.2029 11.3473 12.942 11.6086C12.6807 11.8695 12.3667 11.9999 12 11.9999H6ZM6 10.6666H12V2.66659H6V10.6666ZM3.33333 14.6666C2.96667 14.6666 2.65267 14.5361 2.39133 14.2753C2.13044 14.0139 2 13.6999 2 13.3333V4.66658C2 4.4777 2.064 4.31925 2.192 4.19125C2.31956 4.0637 2.47778 3.99992 2.66667 3.99992C2.85556 3.99992 3.014 4.0637 3.142 4.19125C3.26956 4.31925 3.33333 4.4777 3.33333 4.66658V13.3333H10C10.1889 13.3333 10.3473 13.3973 10.4753 13.5253C10.6029 13.6528 10.6667 13.811 10.6667 13.9999C10.6667 14.1888 10.6029 14.347 10.4753 14.4746C10.3473 14.6026 10.1889 14.6666 10 14.6666H3.33333Z",
    fill: "url(#paint0_linear_391_723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_391_723",
    x1: 2,
    y1: 7.99992,
    x2: 13.3333,
    y2: 7.99992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.2dbc47979f9abf0b32f5aa426c9c9887.svg";
export { ForwardRef as ReactComponent };